import * as React from "react";
import TextInput from "../../components/TextInput";
import {ORION_IMG_URL} from "../../utils/AppConstants";

interface OtherGoalsEditViewContProps {
    otherGoals: string[],
    appointmentId: number
}

interface OtherGoalsEditViewContState {
    updatedOtherGoals: string[]
}

export default class OtherGoalsEditViewCont extends React.Component<OtherGoalsEditViewContProps, OtherGoalsEditViewContState> {

    constructor(props: OtherGoalsEditViewContProps) {
        super(props)
        this.state = this.getStateFromProps(props)
    }

    getStateFromProps = (props: OtherGoalsEditViewContProps): OtherGoalsEditViewContState => {
        let updatedOtherGoals: string[] = props.otherGoals || []
        return {
            updatedOtherGoals
        }
    }

    onGoalChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let updatedOtherGoals = [...this.state.updatedOtherGoals];
        updatedOtherGoals[index] = e.target.value;
        this.setState({
            updatedOtherGoals
        })
    }

    onItemRemove = (index: number) => {
        let updatedOtherGoals = [...this.state.updatedOtherGoals];
        updatedOtherGoals.splice(index, 1);
        this.setState({
            updatedOtherGoals
        })
    }

    getSaveObject = () => {
        return {
            otherGoals: this.state.updatedOtherGoals || [],
            referenceId: this.props.appointmentId.toString()
        }
    }

    render () {
        let otherGoals = [...this.state.updatedOtherGoals];
        otherGoals.push("");
        return (
            <div className={"card-view collapsible-card lc-other-goals-editview-cont"}>
                <div className="header-row">
                    <div className="card-title in-blk mid-align brandon-bold">Top Interventions</div>
                </div>
                <div className={"collapsible-container templated-items"}>
                {
                    otherGoals.map((goal: string, index: number) => {
                        return (
                            <div className={"lc-other-goal-item-cont"}>
                                <TextInput name={"lc-other-goal-item-cont"} value={goal} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onGoalChange(e, index)} placeholder={"Enter a Goal"} />
                                <div className={`remove-btn`} onClick={() => this.onItemRemove(index)}>
                                    <img src={ORION_IMG_URL + "remove-icon.png"} />
                                </div>
                            </div>
                        )
                    })
                }
                </div>
            </div>
        )
    }
}